import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

/**
 *  SelectableContainer is a highly-stylized checkbox or radio input used for tab navigation and other cases. It replaces Checkbox/RadioWithVisual.
 *
 */
const SelectableContainer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    checked,
    suppressed,
    containerClasses,
    inputProps = {},
    onChange = () => {},
    type = 'radio',
    children,
    ...rest
  } = _ref;
  const [isChecked, setIsChecked] = useState(checked);
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  const labelClasses = clsx('selectable-container margin-0', containerClasses, type, {
    suppressed
  });
  const id = inputProps.id ? inputProps.id : inputProps.name;
  return /*#__PURE__*/_jsx("label", {
    "data-cmp": "selectableContainer",
    className: labelClasses,
    htmlFor: id
  }, void 0, /*#__PURE__*/React.createElement("input", Object.assign({
    key: id,
    id: id,
    ref: ref,
    type: type,
    onChange: onChange,
    checked: isChecked
  }, inputProps, rest)), /*#__PURE__*/_jsx("div", {
    className: clsx({
      'radio-input-label': type === 'radio'
    }, 'input-label display-flex justify-content-center')
  }, "content", children && /*#__PURE__*/_jsx("div", {
    className: "selectable-container-content"
  }, void 0, children)));
});
export default SelectableContainer;